import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { PageMetaResolver, ProductLoadingService } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { effects } from './effects';
import { ProductPageMetaResolver } from './resolvers/product-page-meta.resolver';
import { CustomCurrentProductService } from './services/current-product.service';
import { CustomProductLoadingService } from './services/custom-product-loading.service';

@NgModule({
  imports: [EffectsModule.forFeature(effects)],
  providers: [
    { provide: ProductLoadingService, useExisting: CustomProductLoadingService },
    { provide: CurrentProductService, useExisting: CustomCurrentProductService },
    {
      provide: PageMetaResolver,
      useExisting: ProductPageMetaResolver,
      multi: true,
    },
  ],
})
export class ProductFeatureModule {}
